<template>
  <v-row no-gutters class="d-flex justify-space-between fill-height">
    <v-col cols="2"></v-col>
    <v-col @click="changeLanguage('en-US')" cols="4" align="end" justify="end">
      <v-avatar style="z-index: 1" size="65">
        <v-img src="@/assets/en.png"></v-img>
      </v-avatar>
      <v-btn
        elevation="0"
        large
        class="ml-n9 pl-10 py-7 mx-10"
        :color="getCurrentLanguage === 'en-US' ? 'primary' : 'grey lighten-2'"
      >
        English
      </v-btn>
    </v-col>
    <v-col @click="changeLanguage('es-US')" cols="4">
      <v-avatar style="z-index: 1" size="65">
        <v-img src="@/assets/es.png"></v-img>
      </v-avatar>
      <v-btn
        elevation="0"
        large
        class="ml-n9 pl-10 py-7 mx-10"
        :color="getCurrentLanguage === 'es-US' ? 'primary' : 'grey lighten-2'"
      >
        Spanish
      </v-btn>
    </v-col>

    <v-col cols="1" class="d-flex justify-start ">
      <v-menu v-model="adaMenu" offset-y left :close-on-content-click="false" content-class="ada-menu" >
        <template v-slot:activator="{ attrs }">
          <div v-bind="attrs">
            <v-img
              src="@/assets/ada.png"
              width="75"
              contain
              class="cursor-pointer"
              @click.stop="openAdaMenu"
            />
          </div>
        </template>

        <v-card width="360" class="pa-4">
          <strong class="font-weight-bold mb-3 d-block">Accessibility Settings</strong>

          <span class="font-weight-medium mb-2 d-block">Text size</span>
          <v-radio-group v-model="getAccessibilitySettings.textSize" dense class="mt-0">
            <v-radio label="Regular" value="regular" />
            <v-radio label="Large" value="large" />
            <v-radio label="X-Large" value="x-large" />
          </v-radio-group>

          <div class="font-weight-medium mb-2 mt-3">Font</div>
          <v-select
            v-model="getAccessibilitySettings.font"
            :items="fontOptions"
            dense
            outlined
            hide-details
          />

          <div class="font-weight-medium mb-2 mt-4">Contrast</div>
          <v-select
            v-model="getAccessibilitySettings.contrast"
            :items="contrastOptions"
            dense
            outlined
            hide-details
          />

          <div class="font-weight-medium mb-2 mt-4">Spacing</div>
          <v-select
            v-model="getAccessibilitySettings.spacing"
            :items="spacingOptions"
            dense
            outlined
            hide-details
            :disabled="getAccessibilitySettings.font === 'dyslexic'"
          />

          <div class="mt-4">
            <v-checkbox
              v-model="getAccessibilitySettings.highlightHeadings"
              label="Highlight headings"
              dense
              hide-details
            />
          </div>

          <div class="mt-2">
            <v-checkbox
              v-model="getAccessibilitySettings.mouseGuide"
              label="Mouse Reading Guide"
              dense
              hide-details
            />
          </div>

          <div class="mt-2">
            <v-checkbox
              v-model="getAccessibilitySettings.mouseWindow"
              label="Mouse Reading Window"
              dense
              hide-details
            />
          </div>

          <div class="mt-2">
            <v-checkbox
              v-model="getAccessibilitySettings.wheelchair"
              label="Wheelchair Accessibility"
              dense
              hide-details
            />
          </div>

          <v-card-actions class="px-0 pt-4">
            <v-btn text color="grey darken-1" @click="adaMenu = false">
              Close
            </v-btn>
            <v-spacer />
            <v-btn text color="error" @click="resetgetAccessibilitySettings">
              Restore
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-col>

  

    <v-col cols="1"> </v-col>
    <!-- <v-col @click="changeLanguage('nv-US')" cols="2">
      <v-avatar style="z-index:1" size="65">
        <v-img src="@/assets/nv.png"></v-img>
      </v-avatar>
      <v-btn elevation="0" large class="ml-n9 pl-10 py-7">
        Navajo
      </v-btn>
    </v-col>
    <v-col @click="changeLanguage('vi-US')" class="mr-16" cols="2">
      <v-avatar class="ml-n9" style="z-index:1" size="65">
        <v-img src="@/assets/vi.png"></v-img>
      </v-avatar>
      <v-btn elevation="0" large class="ml-n9 pl-10 py-7">
        Vietnamese
      </v-btn>
    </v-col> -->
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "languageBar",
  computed: {
    ...mapGetters(["getTouchCount", "getCurrentLanguage", "getLanguages","getenableADA","getAccessibilitySettings"]),
  },

  watch: {
    getAccessibilitySettings: {
      deep: true,
      handler() {
        this.normalizeSpacingForFont();
        this.applygetAccessibilitySettings();
      },
    },
  },

  
  data() {
    return {
      count: 0,
      adaMenu: false,
      fontOptions: [
        { text: "Standard", value: "standard" },
        { text: "Sans Serif", value: "sans-serif" },
        { text: "Dyslexic", value: "dyslexic" },
      ],
      contrastOptions: [
        { text: "Regular", value: "regular" },
        { text: "Hi-Contrast", value: "hi-contrast" },
        { text: "Desaturate", value: "desaturate" },
        { text: "Invert", value: "invert" },
      ],
      spacingOptions: [
        { text: "Regular", value: "regular" },
        { text: "Wide", value: "wide" },
        { text: "X-Wide", value: "x-wide" },
      ],
      mouseGuideEl: null,
      mouseWindowEl: null,
      lastMouseX: 0,
      lastMouseY: 0,
    };
  },
  methods: {
    normalizeSpacingForFont() {
      if (
        this.getAccessibilitySettings.font === "dyslexic" &&
        this.getAccessibilitySettings.spacing !== "regular"
      ) {
        this.getAccessibilitySettings.spacing = "regular";
      }
    },

    openAdaMenu() {
      this.adaMenu = true;
      this.normalizeSpacingForFont();
      this.applygetAccessibilitySettings();
    },

    isgetAccessibilitySettingsActive() {
      return (
        this.getAccessibilitySettings.textSize !== "regular" ||
        this.getAccessibilitySettings.font !== "standard" ||
        this.getAccessibilitySettings.contrast !== "regular" ||
        this.getAccessibilitySettings.spacing !== "regular" ||
        this.getAccessibilitySettings.highlightHeadings ||
        this.getAccessibilitySettings.wheelchair ||
        this.getAccessibilitySettings.mouseGuide ||
        this.getAccessibilitySettings.mouseWindow
      );
    },

    applygetAccessibilitySettings() {
      this.normalizeSpacingForFont();

      const target = document.getElementById("app") || document.body;

      target.classList.remove(
        "ada-text-regular",
        "ada-text-large",
        "ada-text-x-large",
        "ada-font-standard",
        "ada-font-sans-serif",
        "ada-font-dyslexic",
        "ada-contrast-regular",
        "ada-contrast-hi-contrast",
        "ada-contrast-desaturate",
        "ada-contrast-invert",
        "ada-spacing-regular",
        "ada-spacing-wide",
        "ada-spacing-x-wide",
        "ada-highlight-headings",
        "ada-wheelchair"
      );

      target.classList.add(`ada-text-${this.getAccessibilitySettings.textSize}`);
      target.classList.add(`ada-font-${this.getAccessibilitySettings.font}`);
      target.classList.add(`ada-contrast-${this.getAccessibilitySettings.contrast}`);
      target.classList.add(`ada-spacing-${this.getAccessibilitySettings.spacing}`);

      if (this.getAccessibilitySettings.highlightHeadings) {
        target.classList.add("ada-highlight-headings");
      }

      if (this.getAccessibilitySettings.wheelchair) {
        target.classList.add("ada-wheelchair");
        this.$store.commit("setEnableADA", this.isgetAccessibilitySettingsActive());
      } else {
        this.$store.commit("setEnableADA", false);
      }

      console.log("getAccessibilitySettings Setting: ", this.getAccessibilitySettings);
      this.syncMousegetAccessibilitySettings();
    },

    syncMousegetAccessibilitySettings() {
      if (this.getAccessibilitySettings.mouseGuide) {
        this.ensureMouseGuideEl();
      } else {
        this.removeMouseGuideEl();
      }

      if (this.getAccessibilitySettings.mouseWindow) {
        this.ensureMouseWindowEl();
      } else {
        this.removeMouseWindowEl();
      }
    },

    ensureMouseGuideEl() {
      if (this.mouseGuideEl) return;
      const el = document.createElement("div");
      el.className = "ada-mouse-guide";
      el.setAttribute("aria-hidden", "true");
      el.style.display = "none";
      document.body.appendChild(el);
      this.mouseGuideEl = el;
    },

    removeMouseGuideEl() {
      if (this.mouseGuideEl && this.mouseGuideEl.parentNode) {
        this.mouseGuideEl.parentNode.removeChild(this.mouseGuideEl);
      }
      this.mouseGuideEl = null;
    },

    ensureMouseWindowEl() {
      if (this.mouseWindowEl) return;
      const el = document.createElement("div");
      el.className = "ada-mouse-window";
      el.setAttribute("aria-hidden", "true");
      el.style.display = "none";
      document.body.appendChild(el);
      this.mouseWindowEl = el;
    },

    removeMouseWindowEl() {
      if (this.mouseWindowEl && this.mouseWindowEl.parentNode) {
        this.mouseWindowEl.parentNode.removeChild(this.mouseWindowEl);
      }
      this.mouseWindowEl = null;
    },

    handleMouseMove(event) {
      this.lastMouseX = event.clientX;
      this.lastMouseY = event.clientY;

      const hoveredEl =
        typeof document.elementFromPoint === "function"
          ? document.elementFromPoint(event.clientX, event.clientY)
          : null;

      const insideAdaMenu =
        hoveredEl &&
        typeof hoveredEl.closest === "function" &&
        hoveredEl.closest(".ada-menu");

      if (this.mouseGuideEl) {
        if (insideAdaMenu || !this.getAccessibilitySettings.mouseGuide) {
          this.mouseGuideEl.style.display = "none";
        } else {
          this.mouseGuideEl.style.display = "block";
          this.mouseGuideEl.style.top = `${event.clientY}px`;
        }
      }

      if (this.mouseWindowEl) {
        if (insideAdaMenu || !this.getAccessibilitySettings.mouseWindow) {
          this.mouseWindowEl.style.display = "none";
        } else {
          this.mouseWindowEl.style.display = "block";
          this.mouseWindowEl.style.left = `${event.clientX - 170}px`;
          this.mouseWindowEl.style.top = `${event.clientY - 90}px`;
        }
      }
    },

    resetgetAccessibilitySettings() {
      this.$store.commit("resetAccessibilitySettings");

      const target = document.getElementById("app") || document.body;
      target.classList.remove(
        "ada-text-regular",
        "ada-text-large",
        "ada-text-x-large",
        "ada-font-standard",
        "ada-font-sans-serif",
        "ada-font-dyslexic",
        "ada-contrast-regular",
        "ada-contrast-hi-contrast",
        "ada-contrast-desaturate",
        "ada-contrast-invert",
        "ada-spacing-regular",
        "ada-spacing-wide",
        "ada-spacing-x-wide",
        "ada-highlight-headings",
        "ada-wheelchair"
      );

      this.removeMouseGuideEl();
      this.removeMouseWindowEl();

      this.$store.commit("setEnableADA", false);
      this.adaMenu = false;

      if (typeof this.adaTracking === "function") {
        this.adaTracking();
      }
    },

    adaTracking() {
      this.$store.commit("setTouchRequest", {
        module: "General",
        action: "ADA",
        response: "ADA enabled",
        timeStamp: new Date(),
        requestType: "Touch",
      });

      this.$store.dispatch("addInteractionToPostgres", {
            actionType: "Interaction",
            actionPayload: {
              module: "General",
              navigateFrom: "Home",
              navigateTo: "Home",
              interactionType: "Touch",
              elementContent: "ADA enabled",
            },
          });


    },


    changeLanguage(language) {
      console.log("Languages: ", this.getLanguages);
      this.$store.commit("setTouchCount", this.getTouchCount + 1);
      this.$store.commit("setTouchRequest", {
        module: "Language Change",
        action: "Language changed",
        response: "User Session Started - Touch Detected",
        timeStamp: new Date(),
        requestType: "Session",
      });
      this.$store.dispatch("addInteractionToPostgres", {
        actionType: "Session Started",
        actionPayload: { recognitionType: "Touch" },
      });
      switch (language) {
        case "en-US":
          this.$i18n.locale = "en";
          this.$store.commit("setCurrentLanguage", "en-US");
          this.$store.dispatch("avatarSpeak", "I am now speaking in english");
          this.$store.dispatch("setDefaults", "en");
          this.$store.dispatch("addInteractionToPostgres", {
            actionType: "Interaction",
            actionPayload: {
              module: "Home",
              navigateFrom: "Home",
              navigateTo: "Home",
              interactionType: "Touch",
              elementContent: "English",
            },
          });
          break;
        case "es-US":
          this.$i18n.locale = "es";
          this.$store.commit("setCurrentLanguage", "es-US");
          this.$store.dispatch("avatarSpeak", "Estoy hablando en español");
          this.$store.dispatch("setDefaults", "es");
          this.$store.dispatch("addInteractionToPostgres", {
            actionType: "Interaction",
            actionPayload: {
              module: "Home",
              navigateFrom: "Home",
              navigateTo: "Home",
              interactionType: "Touch",
              elementContent: "Spanish",
            },
          });
          break;
        default:
          break;
      }
    },

    
  },

  mounted() {
    window.addEventListener("mousemove", this.handleMouseMove, {
      passive: true,
    });

    if (this.getenableADA) {
      this.applygetAccessibilitySettings();
    }
  },

  beforeDestroy() {
    //window.removeEventListener("mousemove", this.handleMouseMove);
    //this.removeMouseGuideEl();
    //this.removeMouseWindowEl();
  },
};
</script>

<style>
.btnDim {
  padding-top: 15px;
  padding-bottom: 15px;
}

.cursor-pointer {
  cursor: pointer;
}

/* -------------------------------------------------
   TEXT SIZE
-------------------------------------------------- */
.ada-text-regular .v-card__title,
.ada-text-regular .v-card__text,
.ada-text-regular .v-card-title,
.ada-text-regular .v-card-text,
.ada-text-regular .v-list-item__title,
.ada-text-regular .v-list-item__subtitle,
.ada-text-regular .v-btn__content,
.ada-text-regular .v-label,
.ada-text-regular .text-body-1,
.ada-text-regular .text-body-2,
.ada-text-regular .text-subtitle-1,
.ada-text-regular .text-subtitle-2,
.ada-text-regular .text-h6,
.ada-text-regular p {
  line-height: 1.5 !important;
}

.ada-text-large .v-card__title,
.ada-text-large .v-card__text,
.ada-text-large .v-card-title,
.ada-text-large .v-card-text,
.ada-text-large .v-list-item__title,
.ada-text-large .v-list-item__subtitle,
.ada-text-large .v-btn__content,
.ada-text-large .v-label,
.ada-text-large .text-body-1,
.ada-text-large .text-body-2,
.ada-text-large .text-subtitle-1,
.ada-text-large .text-subtitle-2,
.ada-text-large .text-h6,
.ada-text-large p {
  line-height: 1.6 !important;
}

.ada-text-x-large .v-card__title,
.ada-text-x-large .v-card__text,
.ada-text-x-large .v-card-title,
.ada-text-x-large .v-card-text,
.ada-text-x-large .v-list-item__title,
.ada-text-x-large .v-list-item__subtitle,
.ada-text-x-large .v-btn__content,
.ada-text-x-large .v-label,
.ada-text-x-large .text-body-1,
.ada-text-x-large .text-body-2,
.ada-text-x-large .text-subtitle-1,
.ada-text-x-large .text-subtitle-2,
.ada-text-x-large .text-h6,
.ada-text-x-large p {
  line-height: 1.7 !important;
}

/* Body text */
.ada-text-regular .v-card__text,
.ada-text-regular .v-card-text,
.ada-text-regular .v-list-item__subtitle,
.ada-text-regular .text-body-1,
.ada-text-regular .text-body-2,
.ada-text-regular p,
.ada-text-regular .v-btn__content,
.ada-text-regular .v-label {
  font-size: 20px !important;
}

.ada-text-large .v-card__text,
.ada-text-large .v-card-text,
.ada-text-large .v-list-item__subtitle,
.ada-text-large .text-body-1,
.ada-text-large .text-body-2,
.ada-text-large p,
.ada-text-large .v-btn__content,
.ada-text-large .v-label {
  font-size: 24px !important;
}

.ada-text-x-large .v-card__text,
.ada-text-x-large .v-card-text,
.ada-text-x-large .v-list-item__subtitle,
.ada-text-x-large .text-body-1,
.ada-text-x-large .text-body-2,
.ada-text-x-large p,
.ada-text-x-large .v-btn__content,
.ada-text-x-large .v-label {
  font-size: 28px !important;
}

/* Titles / headings */
.ada-text-regular .v-card__title,
.ada-text-regular .v-card-title,
.ada-text-regular .v-list-item__title,
.ada-text-regular .text-h1,
.ada-text-regular .text-h2:not(.ada-ignore-text-size),
.ada-text-regular .text-h3:not(.ada-ignore-text-size),
.ada-text-regular .text-h4,
.ada-text-regular .text-h5,
.ada-text-regular .text-h6,
.ada-text-regular h1,
.ada-text-regular h2,
.ada-text-regular h3,
.ada-text-regular h4,
.ada-text-regular h5,
.ada-text-regular h6 {
  font-size: 20px !important;
  font-weight: 700 !important;
}

.ada-text-large .v-card__title,
.ada-text-large .v-card-title,
.ada-text-large .v-list-item__title,
.ada-text-large .text-h1,
.ada-text-large .text-h2:not(.ada-ignore-text-size),
.ada-text-large .text-h3:not(.ada-ignore-text-size),
.ada-text-large .text-h4,
.ada-text-large .text-h5,
.ada-text-large .text-h6,
.ada-text-large h1,
.ada-text-large h2,
.ada-text-large h3,
.ada-text-large h4,
.ada-text-large h5,
.ada-text-large h6 {
  font-size: 24px !important;
  font-weight: 700 !important;
}

.ada-text-x-large .v-card__title,
.ada-text-x-large .v-card-title,
.ada-text-x-large .v-list-item__title,
.ada-text-x-large .text-h1,
.ada-text-x-large .text-h2:not(.ada-ignore-text-size),
.ada-text-x-large .text-h3:not(.ada-ignore-text-size),
.ada-text-x-large .text-h4,
.ada-text-x-large .text-h5,
.ada-text-x-large .text-h6,
.ada-text-x-large h1,
.ada-text-x-large h2,
.ada-text-x-large h3,
.ada-text-x-large h4,
.ada-text-x-large h5,
.ada-text-x-large h6 {
  font-size: 28px !important;
  font-weight: 700 !important;
}

/* Buttons / inputs */
.ada-text-large .v-btn,
.ada-text-large .v-input,
.ada-text-large .v-select {
  min-height: 48px !important;
}

.ada-text-x-large .v-btn,
.ada-text-x-large .v-input,
.ada-text-x-large .v-select {
  min-height: 56px !important;
}

/* Header / heading utility classes */
.ada-text-regular .text-h3:not(.ada-ignore-text-size) {
  font-size: 1.75rem !important;
  line-height: 1.3 !important;
  font-weight: 700 !important;
}

.ada-text-large .text-h3:not(.ada-ignore-text-size) {
  font-size: 2.2rem !important;
  line-height: 1.35 !important;
  font-weight: 700 !important;
}

.ada-text-x-large .text-h3:not(.ada-ignore-text-size) {
  font-size: 2.6rem !important;
  line-height: 1.4 !important;
  font-weight: 700 !important;
}

.ada-text-regular .text-h4 {
  font-size: 1.45rem !important;
  line-height: 1.3 !important;
  font-weight: 600 !important;
}

.ada-text-large .text-h4 {
  font-size: 1.9rem !important;
  line-height: 1.35 !important;
  font-weight: 600 !important;
}

.ada-text-x-large .text-h4 {
  font-size: 2.3rem !important;
  line-height: 1.4 !important;
  font-weight: 600 !important;
}

/* -------------------------------------------------
   FONT FAMILY
-------------------------------------------------- */
.ada-font-standard,
.ada-font-standard * {
  font-family: Roboto, sans-serif !important;
}

.ada-font-sans-serif,
.ada-font-sans-serif * {
  font-family: Arial, Helvetica, sans-serif !important;
}

.ada-font-sans-serif .v-card__title,
.ada-font-sans-serif .v-card-title,
.ada-font-sans-serif .v-list-item__title,
.ada-font-sans-serif .text-h1,
.ada-font-sans-serif .text-h2,
.ada-font-sans-serif .text-h3,
.ada-font-sans-serif .text-h4,
.ada-font-sans-serif .text-h5,
.ada-font-sans-serif .text-h6,
.ada-font-sans-serif h1,
.ada-font-sans-serif h2,
.ada-font-sans-serif h3,
.ada-font-sans-serif h4,
.ada-font-sans-serif h5,
.ada-font-sans-serif h6,
.ada-font-sans-serif :not(.ada-menu):not(.ada-menu *) {
  font-family: Arial, Helvetica, sans-serif !important;
}

.ada-font-dyslexic .v-card__title,
.ada-font-dyslexic .v-card-title,
.ada-font-dyslexic .v-list-item__title,
.ada-font-dyslexic .text-h1,
.ada-font-dyslexic .text-h2,
.ada-font-dyslexic .text-h3,
.ada-font-dyslexic .text-h4,
.ada-font-dyslexic .text-h5,
.ada-font-dyslexic .text-h6,
.ada-font-dyslexic h1,
.ada-font-dyslexic h2,
.ada-font-dyslexic h3,
.ada-font-dyslexic h4,
.ada-font-dyslexic h5,
.ada-font-dyslexic h6,
.ada-font-dyslexic :not(.ada-menu):not(.ada-menu *) {
  font-family: "OpenDyslexic", Arial, Helvetica, sans-serif !important;
}

/* keep ADA menu font unchanged when dyslexic mode is enabled */
.ada-font-dyslexic .ada-menu,
.ada-font-dyslexic .ada-menu * {
  font-family: Arial, Helvetica, sans-serif !important;
}

/* -------------------------------------------------
   LETTER SPACING
-------------------------------------------------- */
.ada-spacing-regular .v-card__title,
.ada-spacing-regular .v-card__text,
.ada-spacing-regular .v-card-title,
.ada-spacing-regular .v-card-text,
.ada-spacing-regular .v-list-item__title,
.ada-spacing-regular .v-list-item__subtitle,
.ada-spacing-regular .v-btn__content,
.ada-spacing-regular .v-label,
.ada-spacing-regular .text-body-1,
.ada-spacing-regular .text-body-2,
.ada-spacing-regular .text-subtitle-1,
.ada-spacing-regular .text-subtitle-2,
.ada-spacing-regular .text-h1,
.ada-spacing-regular .text-h2,
.ada-spacing-regular .text-h3,
.ada-spacing-regular .text-h4,
.ada-spacing-regular .text-h5,
.ada-spacing-regular .text-h6,
.ada-spacing-regular p,
.ada-spacing-regular h1,
.ada-spacing-regular h2,
.ada-spacing-regular h3,
.ada-spacing-regular h4,
.ada-spacing-regular h5,
.ada-spacing-regular h6 {
  letter-spacing: normal !important;
  word-spacing: normal !important;
}

.ada-spacing-wide .v-card__title,
.ada-spacing-wide .v-card__text,
.ada-spacing-wide .v-card-title,
.ada-spacing-wide .v-card-text,
.ada-spacing-wide .v-list-item__title,
.ada-spacing-wide .v-list-item__subtitle,
.ada-spacing-wide .v-btn__content,
.ada-spacing-wide .v-label,
.ada-spacing-wide .text-body-1,
.ada-spacing-wide .text-body-2,
.ada-spacing-wide .text-subtitle-1,
.ada-spacing-wide .text-subtitle-2,
.ada-spacing-wide .text-h1,
.ada-spacing-wide .text-h2,
.ada-spacing-wide .text-h3,
.ada-spacing-wide .text-h4,
.ada-spacing-wide .text-h5,
.ada-spacing-wide .text-h6,
.ada-spacing-wide p,
.ada-spacing-wide h1,
.ada-spacing-wide h2,
.ada-spacing-wide h3,
.ada-spacing-wide h4,
.ada-spacing-wide h5,
.ada-spacing-wide h6 {
  letter-spacing: 0.06em !important;
  word-spacing: 0.12em !important;
}

.ada-spacing-x-wide .v-card__title,
.ada-spacing-x-wide .v-card__text,
.ada-spacing-x-wide .v-card-title,
.ada-spacing-x-wide .v-card-text,
.ada-spacing-x-wide .v-list-item__title,
.ada-spacing-x-wide .v-list-item__subtitle,
.ada-spacing-x-wide .v-btn__content,
.ada-spacing-x-wide .v-label,
.ada-spacing-x-wide .text-body-1,
.ada-spacing-x-wide .text-body-2,
.ada-spacing-x-wide .text-subtitle-1,
.ada-spacing-x-wide .text-subtitle-2,
.ada-spacing-x-wide .text-h1,
.ada-spacing-x-wide .text-h2,
.ada-spacing-x-wide .text-h3,
.ada-spacing-x-wide .text-h4,
.ada-spacing-x-wide .text-h5,
.ada-spacing-x-wide .text-h6,
.ada-spacing-x-wide p,
.ada-spacing-x-wide h1,
.ada-spacing-x-wide h2,
.ada-spacing-x-wide h3,
.ada-spacing-x-wide h4,
.ada-spacing-x-wide h5,
.ada-spacing-x-wide h6 {
  letter-spacing: 0.12em !important;
  word-spacing: 0.18em !important;
}

/* -------------------------------------------------
   CONTRAST
-------------------------------------------------- */
.ada-contrast-regular {
  filter: none !important;
  background: inherit;
  color: inherit;
}

.ada-contrast-hi-contrast {
  filter: contrast(1.4) brightness(1.05) !important;
}

.ada-contrast-desaturate {
  filter: grayscale(1) saturate(0.2) !important;
}

.ada-contrast-invert {
  filter: invert(1) hue-rotate(180deg) !important;
}

.ada-contrast-hi-contrast .v-card,
.ada-contrast-hi-contrast .theme--light.v-sheet,
.ada-contrast-hi-contrast .theme--light.v-btn {
  border: 2px solid #000 !important;
}

/* -------------------------------------------------
   HEADING HIGHLIGHT
-------------------------------------------------- */
.ada-highlight-headings .v-card__title,
.ada-highlight-headings .v-card-title,
.ada-highlight-headings .v-list-item__title,
.ada-highlight-headings .text-h1,
.ada-highlight-headings .text-h2,
.ada-highlight-headings .text-h3,
.ada-highlight-headings .text-h4,
.ada-highlight-headings .text-h5,
.ada-highlight-headings .text-h6,
.ada-highlight-headings h1,
.ada-highlight-headings h2,
.ada-highlight-headings h3,
.ada-highlight-headings h4,
.ada-highlight-headings h5,
.ada-highlight-headings h6 {
  background: #ffeb3b !important;
  color: #000 !important;
  padding: 4px 8px !important;
  border-radius: 4px !important;
  display: inline-block;
}

.ada-highlight-headings .text-h3,
.ada-highlight-headings .text-h4 {
  background: #ffeb3b !important;
  color: #000 !important;
  padding: 4px 8px !important;
  border-radius: 4px !important;
  display: inline-block !important;
}

/* -------------------------------------------------
   ADA MENU - DO NOT SCALE
-------------------------------------------------- */
.ada-menu {
  z-index: 10050 !important;
}

.ada-menu .v-card {
  border-radius: 12px !important;
}

.ada-text-regular .ada-menu,
.ada-text-large .ada-menu,
.ada-text-x-large .ada-menu {
  font-size: 16px !important;
  line-height: 1.4 !important;
}

.ada-text-regular .ada-menu strong,
.ada-text-large .ada-menu strong,
.ada-text-x-large .ada-menu strong {
  font-size: 18px !important;
  line-height: 1.4 !important;
}

.ada-text-regular .ada-menu .font-weight-medium,
.ada-text-large .ada-menu .font-weight-medium,
.ada-text-x-large .ada-menu .font-weight-medium,
.ada-text-regular .ada-menu .v-label,
.ada-text-large .ada-menu .v-label,
.ada-text-x-large .ada-menu .v-label,
.ada-text-regular .ada-menu .v-input__slot,
.ada-text-large .ada-menu .v-input__slot,
.ada-text-x-large .ada-menu .v-input__slot,
.ada-text-regular .ada-menu .v-select__selection,
.ada-text-large .ada-menu .v-select__selection,
.ada-text-x-large .ada-menu .v-select__selection,
.ada-text-regular .ada-menu .v-btn__content,
.ada-text-large .ada-menu .v-btn__content,
.ada-text-x-large .ada-menu .v-btn__content,
.ada-text-regular .ada-menu .v-messages,
.ada-text-large .ada-menu .v-messages,
.ada-text-x-large .ada-menu .v-messages,
.ada-text-regular .ada-menu span,
.ada-text-large .ada-menu span,
.ada-text-x-large .ada-menu span,
.ada-text-regular .ada-menu div,
.ada-text-large .ada-menu div,
.ada-text-x-large .ada-menu div {
  font-size: 16px !important;
  line-height: 1.4 !important;
  letter-spacing: normal !important;
  word-spacing: normal !important;
}

/* Prevent text-size mode from enlarging controls inside the popup */
.ada-text-large .ada-menu .v-btn,
.ada-text-large .ada-menu .v-input,
.ada-text-large .ada-menu .v-select,
.ada-text-x-large .ada-menu .v-btn,
.ada-text-x-large .ada-menu .v-input,
.ada-text-x-large .ada-menu .v-select {
  min-height: auto !important;
}

/* Keep select height normal */
.ada-menu .v-input__slot {
  min-height: 40px !important;
}

.ada-menu .v-select__slot,
.ada-menu .v-text-field__slot {
  min-height: 40px !important;
  align-items: center !important;
}

/* Keep radio / checkbox labels and controls normal */
.ada-menu .v-radio .v-label,
.ada-menu .v-checkbox .v-label,
.ada-menu .v-input--radio-group .v-label,
.ada-menu .v-input--selection-controls .v-label {
  font-size: 16px !important;
  line-height: 1.4 !important;
  letter-spacing: normal !important;
  word-spacing: normal !important;
}

.ada-menu .v-input--selection-controls__input {
  width: 24px !important;
  height: 24px !important;
  flex: 0 0 24px !important;
}

.ada-menu .v-input--selection-controls__ripple {
  width: 34px !important;
  height: 34px !important;
  transform: scale(1) !important;
}

.ada-menu .v-radio,
.ada-menu .v-checkbox {
  margin-top: 4px !important;
  margin-bottom: 4px !important;
}

.ada-menu .v-btn__content {
  font-size: 16px !important;
  letter-spacing: normal !important;
  word-spacing: normal !important;
}

/* -------------------------------------------------
   MOUSE GUIDE / WINDOW
-------------------------------------------------- */
.ada-mouse-guide {
  position: fixed;
  left: 0;
  width: 100vw;
  height: 4px;
  transform: translateY(-50%);
  background: rgba(255, 235, 59, 0.95);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15);
  pointer-events: none;
  z-index: 9990;
}

.ada-mouse-window {
  position: fixed;
  width: 340px;
  height: 180px;
  border: 3px solid rgba(255, 235, 59, 0.98);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.34);
  pointer-events: none;
  z-index: 9989;
}
</style>
